import {
  PROJECT_ON_BOARD_APISAVE_DATA_CALL_BEGIN,
  PROJECT_ON_BOARD_APISAVE_DATA_CALL_SUCCESS,
  PROJECT_ON_BOARD_APISAVE_DATA_CALL_FAILURE,
  PROJECT_ON_BOARD_APISAVE_DATA_CALL_DISMISS_ERROR,
} from './constants';
import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

export function apisaveDataCall(args = {}) {
  return (dispatch) => {
    dispatch({
      type: PROJECT_ON_BOARD_APISAVE_DATA_CALL_BEGIN,
    });
    const { projectId, version, dataForSave } = args
    console.log('args', args);
    const header = builderSurfaceJsonContentHeader(projectId);
    console.log('header', header);

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/xanoNew/xano-post`,
        dataForSave,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: PROJECT_ON_BOARD_APISAVE_DATA_CALL_SUCCESS,
            data: res.data.data,
          });
          resolve(res);
          console.log('posting data', res.data);
        },

        (err) => {
          dispatch({
            type: PROJECT_ON_BOARD_APISAVE_DATA_CALL_FAILURE,
            data: { error: err },
          });
          reject(err);
          console.log('error posting', err);
        },
      );
    });

    return promise;
  };
}

export function dismissApisaveDataCallError() {
  return {
    type: PROJECT_ON_BOARD_APISAVE_DATA_CALL_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PROJECT_ON_BOARD_APISAVE_DATA_CALL_BEGIN:
      return {
        ...state,
        apisaveDataCallPending: true,
        apisaveDataCallError: null,
      };

    case PROJECT_ON_BOARD_APISAVE_DATA_CALL_SUCCESS:
      return {
        ...state,
        apisaveDataCallPending: false,
        apisaveDataCallError: null,
        apiResponseData: action.data,
      };

    case PROJECT_ON_BOARD_APISAVE_DATA_CALL_FAILURE:
      return {
        ...state,
        apisaveDataCallPending: false,
        apisaveDataCallError: action.data.error,
      };

    case PROJECT_ON_BOARD_APISAVE_DATA_CALL_DISMISS_ERROR:
      return {
        ...state,
        apisaveDataCallError: null,
      };

    default:
      return state;
  }
}
